import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function WhyItFailed() {
  const reasons = ['Melatonin treats your pineal gland, but it does nothing to stop the physical heat spike that wakes you up.', 'Cotton sheets actually trap moisture and heat, creating a "sauna effect" that triggers second and third wake-ups.', 'Standard sleep hygiene doesn\'t account for the "Estrogen-Cortisol Handshake" that happens in your liver at 3 AM.', 'Staying in bed and "fighting it" creates a neural association between your mattress and anxiety.'];
  return <section className="py-16 md:py-24 px-4 bg-night-900" data-id="element-197">
      <div className="max-w-4xl mx-auto" data-id="element-198">
        <FadeIn data-id="element-199">
          <h3 className="font-serif text-3xl md:text-4xl text-white mb-12 text-center" data-id="element-200">
            Why What You Tried Didn't Work
          </h3>
        </FadeIn>

        <div className="space-y-6" data-id="element-201">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-202">
              <div className="flex items-start gap-4 p-6 rounded-xl bg-night-800/50 border border-night-700/50 hover:border-night-600 transition-colors" data-id="element-203">
                <XCircle className="w-6 h-6 text-red-400/80 shrink-0 mt-1" data-id="element-204" />
                <p className="text-lg text-cream/90 leading-relaxed" data-id="element-205">
                  {reason}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}